/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, w, SCS) {
	'use strict';
	/* globals Tc, debug */

	/**
	 * Module for Help Interactive Video component.
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class InteractiveVideo
	 * @extends Tc.Module
	 * @version 1.2
	 */
	Tc.Module.InteractiveVideo = Tc.Module.extend({
		// jshint camelcase: false
		// FIXME: convert variables and properties to camelcase

		/**
		 * Default classes for this module
		 */
		SCS_INTERACTIVE_VIDEO_CLASS : 'scs-interactiveVideo',
		SCS_INTERACTIVE_VIDEO_BUTTON_CLASS : 'scs-interactiveVideo-button',
		SCS_INTERACTIVE_VIDEO_LOADER_CLASS : 'scs-interactiveVideo-loader',
		SCS_INTERACTIVE_VIDEO_CONTROL_CLASS : 'scs-interactiveVideo-controls',
		SCS_INTERACTIVE_VIDEO_REFERENT_WIDTH : 700,
		SCS_INTERACTIVE_VIDEO_REFERENT_HEIGHT : 394,

		/**
		 * Main function.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on : function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			// Module vars
			mod.isEditMode = $('.cq_isEditMode').length;
			mod.isMobilePage = SCS.utils.isMobilePage();
			mod.isEndless = w.location.search.indexOf('endless') !== -1;

			// Set special object for this module, iv = interactive_video
			mod.iv = {

				// Declare module array of processed videos
				videos_elements_byIDs: [],

				// Loader event
				loader_event: true,

				// Default video quality
				videoQuality: mod.isMobilePage ? 'default' : 'hd720',

				// Video buttons that are hidden
				hidden_buttons: [],

				// Create and store old and new URL when hash change
				// We are doing this because mighty IE doesn't support oldURL / newURL attributes on hash change
				old_url_onhashchange: '',

				// Store navigation buttons width for wrapper left animation
				control_buttons: {}
			};

			// Cache videos elements
			mod.iv.videos_elements = $('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video', $ctx);
			mod.iv.videos_element = mod.iv.videos_elements.eq(0);

			// Get first video ID
			mod.iv.first_video_id = mod.iv.videos_elements.eq(0).data('videoid');

			// Get all buttons
			mod.iv.videos_buttons = mod.iv.videos_elements.find('.' + mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS);

			// Cache navigation buttons element and buttons
			mod.iv.control_buttons_element = $('.' + mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS, $ctx);
			mod.iv.control_buttons_elements = $('> span', mod.iv.control_buttons_element);

			if (mod.isMobilePage) {

				// Referent player size
				mod.iv.player = {};

				// Set mod.iv.player properties
				mod.setPlayerSizeForCompare(mod.iv.videos_element, true);

				// Start listening for window resize
				mod.onResizeChange();

			} else {

				// Since entire module is available in DOM we will now add qtip to every button images
				mod.iv.videos_buttons.find('> img').qtip();

				// Also add tooltip to navigation buttons
				$('.' + mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + ' > span', $ctx).qtip({
					position: {
						my: 'top center',
						at: 'bottom center'
					}
				});
			}

			// Start listening for hash tag
			mod.onHashChange();

			// Lets fire up the engine :)
			mod.getIDandStartProcessing();

			callback();
		},

		/**
		 * Helper function that count the occurrences of substring in a string
		 *
		 * @param string {String} Required. The string
		 * @param subString {String} Required. The string to search for
		 *
		 * @return n {Integer} Number of occurrences
		 */
		stringOccurrences : function (string, subString) {
			string += '';
			subString += '';

			var $n = 0,
				$pos = 0,
				$step = subString.length;

			if(subString.length <= 0) {
				return string.length + 1;
			}

			while(true) {
				$pos = string.indexOf(subString, $pos);
				if($pos >= 0) {
					$n += 1;
					$pos += $step;
				} else {
					break;
				}
			}

			return($n);
		},

		/**
		 * Helper function to calculate time format HH:MM:SS to seconds
		 *
		 * @params time {String} Time in format (HH:)MM:SS
		 */
		convertTimeToSeconds : function(time) {
			var timeArray = time.toString().split(':'),
				seconds = 0,
				minutes = 1;

			while (timeArray.length > 0) {
				seconds += minutes * parseInt(timeArray.pop(), 10);
				minutes *= 60;
			}

			return seconds;
		},

		/**
		 * We are monitoring hash change in URL for this module
		 * If hash changes, we then process video element with new ID from URL
		 */
		onHashChange : function() {
			var mod = this,
				newUrl, oldUrl;

			// Check if browser support hash change event
			if ('onhashchange' in w) {

				// Start hash change event
				w.onhashchange = function(event) {

					// Check if we are in IE
					if (typeof event !== 'undefined' && w.ActiveXObject === undefined) {
						newUrl = event.newURL;
						oldUrl = event.oldURL;
					} else {
						newUrl = location.href;
						oldUrl = mod.iv.old_url_onhashchange;
					}

					// Get ID from new URL and start processing it
					mod.processURLsForID(newUrl, oldUrl);
				};

			} else {

				// Browser doesn't support hash change event and we will mimic it
				setInterval(function() {

					// Get ID from new URL and start processing it
					mod.processURLsForID(location.href, mod.iv.old_url_onhashchange);
				}, 100);
			}
		},

		/**
		 * Process the video element with new ID from URL
		 *
		 * @param newUrl {String} Current URL
		 * @param oldUrl {String} URL before hash update
		 */
		processURLsForID : function(newUrl, oldUrl) {
			var mod = this,
				newUrlId,
				oldUrlId;

			// First check if we have interactive_video hash tag in new URL
			if (newUrl.indexOf('#interactive_video_' + mod.id + '=') !== -1) {
				newUrlId = mod.getVideoIDfromURL(newUrl);
				oldUrlId = mod.getVideoIDfromURL(oldUrl);

				// Then check if we have good ID from new URL if new video ID is different then old one (if present)
				if (mod.sanitizeVideoID(newUrlId) && newUrlId !== oldUrlId) {
					mod.getIDandStartProcessing(newUrlId);
				}
			} else {
				mod.getIDandStartProcessing(mod.iv.first_video_id);
			}
		},

		/**
		 * Get video ID from current or passed URL
		 *
		 * @param url {String} URL to get ID
		 *
		 * @return $video_id {String} YouTube video ID
		 */
		getVideoIDfromURL : function(url) {
			var mod = this,
				$video_id = '',
				$current_url = (typeof url !== 'undefined' ? url : location.href),
				$url_hashtag = $current_url.substr($current_url.indexOf('#') + 1);

			// Check hashtag for video ID
			if ($url_hashtag.indexOf('interactive_video_' + mod.id + '=') !== -1) {

				// Because URL can hold multiple hash tags we will split it by #
				$url_hashtag = $url_hashtag.split('#');
				$.each($url_hashtag, function(index, value) {
					if (value.indexOf('interactive_video_' + mod.id + '=') !== -1) {
						value = value.split('=');
						$video_id = value[1];
					}
				});
			}

			return $video_id;
		},

		/**
		 * Little sanitization of video ID
		 *
		 * @param video_id {String} YouTube video ID
		 *
		 * @return $video_id_test {Boolean} True if video is in good format, false otherwise
		 */
		sanitizeVideoID : function(video_id) {
			var $video_id_test = true,
				$id_regex_check = /^[\w-]+$/;

			// Lets perform a little sanity check of ID
			if (!$id_regex_check.test(video_id) || video_id.length < 11) {
				$video_id_test = false;
			}

			return $video_id_test;
		},

		/**
		 * Introduction function to get video ID and start processing corresponding video element
		 *
		 * @param video_id {String} YouTube video ID
		 */
		getIDandStartProcessing : function(video_id) {
			var mod = this;

			// Check if need to get video ID
			if (typeof video_id === 'undefined') {
				video_id = mod.getVideoID();
			}

			// Start processing ID
			if (video_id) {
				mod.processVideoID(video_id);
				mod.iv.currentVideo = video_id;
			} else {
				debug.log('Tc.Module.InteractiveVideo.js > Unable to get video ID for processing');
			}
		},

		/**
		 * Check URL for video ID or get from first video element
		 *
		 * @return $video_id {String} YouTube video ID
		 */
		getVideoID : function() {
			var mod = this,
				$video_id = mod.getVideoIDfromURL();

			// If video ID isn't found in current URL get ID from first video in component
			if (!$video_id) {
				$video_id = mod.iv.first_video_id;
			}

			// Check if ID is valid
			if(!mod.sanitizeVideoID($video_id)) {
				$video_id = '';
			}

			return $video_id;
		},

		/**
		 * Update current URL with videoID hash tag
		 *
		 * @param video_id {String} YouTube video ID
		 */
		updateURLHashTag : function(video_id) {
			var mod = this,
				$current_url = location.href,
				$url_hashtag = $current_url.substr($current_url.indexOf('#') + 1),
				$hashtag_count = mod.stringOccurrences($current_url, '#'),
				$new_hashtag;

			// Check if URL have hash tags
			switch ($hashtag_count) {

				// No hash tag
				case 0:
					$new_hashtag = 'interactive_video_' + mod.id + '=' + video_id;
					break;

				// Only one hash tag
				case 1:
					// mod.iv.first_video_id
					if ($url_hashtag.indexOf('interactive_video_' + mod.id + '=') !== -1) {
						$new_hashtag = 'interactive_video_' + mod.id + '=' + video_id;
					} else {
						$new_hashtag = $url_hashtag + '#interactive_video_' + mod.id + '=' + video_id;
					}
					break;

				// Two or more hash tags
				default:
					if ($current_url.indexOf('interactive_video_' + mod.id + '=') !== -1) {

						// This is a little tricky and we need to break it in order to replace video ID
						$url_hashtag = $url_hashtag.split('#');
						$.each($url_hashtag, function(index, value) {
							if (value.indexOf('interactive_video_' + mod.id + '=') !== -1) {
								value = value.split('=');
								$url_hashtag[index] = value[0] + '=' + video_id;
							}
						});

						// And now put it back together for update
						$new_hashtag = $url_hashtag.join('#');
					} else {
						$new_hashtag = $url_hashtag + '#interactive_video_' + mod.id + '=' + video_id;
					}

					break;
				}

				// Store old URL to
				mod.iv.old_url_onhashchange = $current_url;

				// Set video ID hash tag
				w.location.hash = $new_hashtag;
		},

		/**
		 * Main power plant for processing video ID
		 *
		 * @param video_id {String} YouTube video ID
		 */
		processVideoID : function(video_id) {
			var mod = this,
				foundVideoElement;

			// Check video ID
			if (typeof video_id === 'undefined') {
				debug.log('Tc.Module.InteractiveVideo.js > Please check video ID');
				return false;
			}

			// Now check if this element is already in mod.iv.videos_elements array
			if (typeof mod.iv.videos_elements_byIDs[video_id] === 'undefined') {
				foundVideoElement = mod.importVideoElement(video_id, true);
			} else {
				foundVideoElement = mod.importVideoElement(video_id);
			}

			// Check if we have video element by desired ID
			if (foundVideoElement) {

				// Process video buttons
				if (mod.isEditMode) {
					mod.prepareButtons(mod.iv.videos_elements);
				} else {
					mod.prepareButtons(mod.iv.videos_elements_byIDs[video_id]);
				}

				// Fire up YouTube API
				mod.youtubeAPI(mod.iv.videos_elements_byIDs[video_id]);

				// Player control buttons
				if (!mod.isEditMode) {
					mod.videoControls(mod.iv.videos_elements_byIDs[video_id]);
				}
			} else {
				debug.log('Tc.Module.InteractiveVideo.js > Couldn\'t find video element by data-videoid attribute equal to: ' + video_id);
			}
		},

		/**
		 * Import wanted video element into DOM
		 *
		 * @param video_id {String} YouTube video ID
		 * @param new_video_element {Boolean} Do we need to import new video element
		 *
		 * @return foundVideoElement {Boolean} Return true if element with video_id exist
		 */
		importVideoElement : function(video_id, new_video_element) {
			var mod = this,
				$video_element,
				foundVideoElement = false;

			// First hide all videos and then show needed one
			if (!mod.isEditMode) {
				mod.iv.videos_elements.hide();
			}

			// Now check if we need to assign new video element to mod.iv.videos_elements_byIDs object
			if (new_video_element === true) {
				$.each(mod.iv.videos_elements, function() {
					$video_element = $(this);

					if ($video_element.data('videoid') === video_id) {

						// Process and set video start and end time
						$video_element.start_seconds = mod.convertTimeToSeconds($video_element.data('startvideo'));
						$video_element.end_seconds = mod.convertTimeToSeconds($video_element.data('stopvideo'));

						// Show this video element
						$video_element.show();

						// Assign element
						mod.iv.videos_elements_byIDs[video_id] = $video_element;
						foundVideoElement = true;

						// Break from iteration
						return false;
					}
				});
			} else {
				mod.iv.videos_elements_byIDs[video_id].show();
				foundVideoElement = true;
			}

			return foundVideoElement;
		},

		/**
		 * Setup overlay buttons for video
		 *
		 * @param video_element {Object} Video element object
		 */
		prepareButtons : function(video_element) {
			var mod = this,
				$video_buttons = $('.' + mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS, video_element),
				$button;

			// Reset hidden_buttons array if it's set
			if (mod.iv.hidden_buttons.length) {
				mod.iv.hidden_buttons = [];
			}

			// Check if we have buttons on this video
			if ($video_buttons.length) {

				// Iterate all buttons and setup necessary properties
				$.each($video_buttons, function() {
					$button = $(this);

					// On mobile we need to resize button to match video size
					if (mod.isMobilePage) {
						mod.resizeOverlayButtons($button);
					}

					// Set button position if needed
					mod.prepareButtonPosition(video_element, $button);

					// Now check if button has time table
					mod.checkButtonTimeTable(video_element.start_seconds, $button);

					// Finally check button URL and click event
					mod.addButtonEvent($button);
				});
			}
		},

		/**
		 * Set button position for middle column and center row
		 *
		 * @param video_element {Object} Video element object
		 * @param button {Object} Video button element
		 */
		prepareButtonPosition : function(video_element, button) {
			var mod = this,
				$button_image = button.find('> img');

			// Just in case check if we have button
			if (typeof button === 'undefined') {
				debug.log('Tc.Module.InteractiveVideo.js > Iterate function returned empty video button.');
			}

			// Check if the button is image
			if ($button_image.length) {
				if (mod.isLoaded(video_element)) {
					mod.overlayButtonsDimensions(button, button.width(), button.height());
				} else {
					$button_image.on('load', function(){
						mod.overlayButtonsDimensions(button, button.width(), button.height());
					});
				}
			} else {
				mod.overlayButtonsDimensions(button, button.width(), button.outerHeight(false));
			}
		},

		/**
		 * Button time table, if button has limited time window hide it and sent it to mod.iv.hidden_buttons array
		 *
		 * @param start_video_time {Integer} Video start time in seconds
		 * @param button {Object} Video button element
		 */
		checkButtonTimeTable : function(start_video_time, button) {
			var mod = this,
				$button_show_time = mod.convertTimeToSeconds(button.data('showtime'));

			// Check is this button should start with the video
			if ($button_show_time <= start_video_time) {
				button.css('visibility', 'visible');
			} else {
				button.show_time = $button_show_time;
				button.hide_time = mod.convertTimeToSeconds(button.data('hidetime'));
				mod.iv.hidden_buttons.push(button);
			}
		},

		/**
		 * Add button click event
		 *
		 * @param button {Object} Video button element
		 */
		addButtonEvent : function(button) {
			var mod = this,
				button_href = $.trim(button.attr('href')),
				buttonEvent = parseFloat(button.jquery) < 1.8 ? $.data(button[0], 'events') : $._data(button[0], 'events');

			// Check if button href contains video ID
			if (button_href.substring(0, 1) === '#' && button_href.length > 11 && !(buttonEvent || {}).hasOwnProperty('click')) {

				// Remove wcmmode and endless query parameters from href
				if (mod.isEndless && button_href.indexOf('&endless') !== -1) {
					button_href = button_href.replace('?wcmmode=disabled&endless', '');
					button.attr('href', button_href);
				}

				button.click(function(event) {
					event.preventDefault();

					// Update hash tag in URL
					if (!mod.isEditMode) {
						mod.iv.videos_buttons.css('visibility', '');
						mod.updateURLHashTag(button_href.substring(1));
					}
				});
			}
		},

		/**
		 * Start preparation for YouTube API
		 *
		 * @param video_element {Object} DOM video element object
		 */
		youtubeAPI : function(video_element) {
			var mod = this;

			// Declare onYouTubeIframeAPIReady function if needed
			if (typeof(w.onYouTubeIframeAPIReady) !== 'function') {
				w.onYouTubeIframeAPIReady = function() {

					// Set new YouTube API player
					mod.youtubePlayerStart(video_element);
				};
			} else {

				// We are just updating the player
				mod.youtubePlayerStart(video_element);
			}

			// Check if iframe API is loaded into document head
			if (w.YT === undefined) {
				mod.youtubeAPIScript('https://www.youtube.com/iframe_api');
			}
		},

		/**
		 * Helper function to add YouTube iframe API to document head
		 *
		 * @param url {String} Script URL to include into document head
		 * @param callback {Object} Callback when script was included and loaded
		 */
		youtubeAPIScript : function(url, callback) {
			var $document = document,
				$script = 'script',
				$iframeAPI = $document.createElement($script),
				$scripts = $document.getElementsByTagName($script)[0],
				$iframeApiState;

			// Set script object
			$iframeAPI.type = 'text/java' + $script;
			$iframeAPI.src = url;

			// Scripts that are dynamically created and added to the document are async by default
			$iframeAPI.async = false;

			// Check callback
			if (callback === 'function') {
				$iframeAPI.onreadystatechange = $iframeAPI.onload = function() {
					$iframeApiState = $iframeAPI.readyState;
					if (!callback.done && (!$iframeApiState || /loaded|complete/.test($iframeApiState))) {
						callback.done = true;
						callback();
					}
				};
			}

			// Insert it before first script in the head
			$scripts.parentNode.insertBefore($iframeAPI, $scripts);
		},

		/**
		 * Update YouTube player object or start creating new one
		 *
		 * @param video_element {Object} DOM video element object
		 */
		youtubePlayerStart : function(video_element) {
			var mod = this,
				$ctx = mod.$ctx;

			// Check if we already have declared YouTube player for this module
			if (typeof mod.iv.youtubePlayerObject !== 'undefined') {
				mod.iv.youtubePlayerObject.loadVideoById({
					'videoId': video_element.data('videoid'),
					'startSeconds': video_element.start_seconds,
					'endSeconds': video_element.end_seconds,
					'suggestedQuality': mod.iv.videoQuality
				});
			} else {

				// Preliminary check if we are in edit mode
				if (mod.isEditMode) {
					$('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video', $ctx).each(function() {
						mod.youtubePlayer($(this));
					});
				} else {
					mod.youtubePlayer(video_element);
				}
			}
		},

		/**
		 * YouTube player object
		 *
		 * @param video_element {Object} DOM video element object
		 */
		youtubePlayer : function(video_element) {
			var mod = this,
				$ctx = mod.$ctx;

			// Create new Youtube player object
			mod.iv.youtubePlayerObject = new w.YT.Player(
				$('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-ytPlaceholder', (mod.isEditMode ? video_element : $ctx))[0], {

					// Player vars
					height: '100%',
					width: '100%',
					videoId: video_element.data('videoid'),
					playerVars: {
						autoplay: 0,
						controls: 1,
						enablejsapi: 1,
						modestbranding: 1,
						showinfo: 0,
						rel: 0,
						iv_load_policy: 3,
						vq: mod.iv.videoQuality,
						wmode: 'transparent',
						fs: 0,
						origin: encodeURIComponent(w.location.protocol + '//' + w.location.host),
						start: video_element.start_seconds,
						end: video_element.end_seconds
					},
					events: {
						'onReady': function() {

							// Hide loader when player is ready
							if (mod.iv.loader_event) {
								mod.loadingEvent();
							}
						},
						'onStateChange': function(event) {

							// Check if we have any buttons with time table
							if (mod.iv.hidden_buttons.length) {
								mod.monitorPlayerTime(event.data);
							}
						}
					}
			});
		},

		/**
		 * Check player status for playing, stop and paused event
		 *
		 * @param player_status {object} Player status retrieved from player event object
		 */
		monitorPlayerTime : function(player_status) {
			var mod = this;

			// Lets check player status
			switch (player_status) {

				// Playing
				case w.YT.PlayerState.PLAYING:

					// Hide
					if (mod.iv.youtubePlayerObject.getCurrentTime() <= 0.3) {
						mod.iv.videos_buttons.css('visibility', '');
					}

					// Set interval to check player time every 400 milliseconds
					mod.iv.play_time = setInterval(function() {
						mod.showHideVideoButtons(mod.iv.youtubePlayerObject.getCurrentTime());
					}, 400);

					break;

				// Ended or paused
				case w.YT.PlayerState.ENDED:
				case w.YT.PlayerState.PAUSED:
					clearInterval(mod.iv.play_time);
					break;
			}
		},

		/**
		 * Show and hide video buttons with time table
		 *
		 * @param time {Integer} Current player time in seconds point milliseconds
		 */
		showHideVideoButtons : function(time) {
			var mod = this;

			// Check hidden elements
			$.each(mod.iv.hidden_buttons, function() {

				// Check if we are ready to show this button
				if (this.show_time <= time) {
					this.css('visibility', 'visible');
				}

				// Check if we need to hide this button
				if (this.hide_time > 0 && (this.hide_time <= time || time < this.show_time)) {
					this.css('visibility', 'hidden');
				}
			});
		},

		/**
		 * Prepare control buttons for videos
		 *
		 * @param video_element {Object} DOM video element object
		 */
		videoControls : function(video_element) {
			var mod = this,
				$control_button,
				$previous_video_element = video_element.parent().prev().children('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video'),
				$next_video_element = video_element.parent().next().children('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video'),
				$video_id = video_element.data('videoid'),
				$control_buttons_width = 0;

			// Iterate transla each button and set it click action
			$.each(mod.iv.control_buttons_elements, function(index) {

				// Create jQuery object for this button
				$control_button = $(this);

				// Add buttons width to control buttons object
				if (mod.iv.control_buttons[index] === undefined) {
					mod.iv.control_buttons[index] = (parseInt($control_button.outerWidth(true), 10) / 2);
				}

				// Remove any previous attached clicks
				$control_button.off('click');

				// Start from beginning
				if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-beginning')) {
					if ($video_id !== mod.iv.first_video_id) {
						$control_button.show('slow').click(function() {
							mod.updateURLHashTag(mod.iv.first_video_id);
						});

						$control_buttons_width += mod.iv.control_buttons[index];

					} else {
						$control_button.hide('slow');
					}

				// Reload current video - always visible
				} else if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-reload')) {
					$control_button.show('slow').click(function() {
						if (mod.iv.youtubePlayerObject !== 'undefined') {
							mod.iv.youtubePlayerObject.loadVideoById({
								'videoId': $video_id,
								'startSeconds': video_element.start_seconds,
								'endSeconds': video_element.end_seconds,
								'suggestedQuality': mod.iv.videoQuality
							});
						} else {
							debug.log('Tc.Module.InteractiveVideo.js > YouTube player object "mod.iv.youtubePlayerObject" is undefined?');
						}
					});

					$control_buttons_width += mod.iv.control_buttons[index];

				// Previous video
				} else if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-previous')) {

					if ($previous_video_element.length) {

						$control_button.show('slow').click(function() {
							window.history.back();
						});
						$control_buttons_width += mod.iv.control_buttons[index];

					} else {
						$control_button.hide('slow');
					}

				// Next video
				} else if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-next')) {
					if ($next_video_element.length) {
						$control_button.show('slow').click(function() {
							mod.updateURLHashTag($next_video_element.data('videoid'));
						});
						$control_buttons_width += mod.iv.control_buttons[index];
					} else {
						$control_button.hide('slow');
					}
				}
			});

			// Set new left margin for navigation buttons
			mod.iv.control_buttons_element.animate({'margin-left': -$control_buttons_width});
		},

		/**
		 * Hide or show video loading overlay
		 * Currently we are only hiding it on first load
		 */
		loadingEvent : function() {
			var mod = this,
				$ctx = mod.$ctx,
				$loader_element = $('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-loader', $ctx);

			// Check loader status
			if ($loader_element.is(':visible')) {
				$loader_element
					.toggleClass(mod.SCS_INTERACTIVE_VIDEO_LOADER_CLASS + '-visible ' + mod.SCS_INTERACTIVE_VIDEO_LOADER_CLASS + '-hidden')
					.fadeOut('slow');

				mod.iv.loader_event = false;
			}
		},

		/**
		 * Set player size for comparison
		 *
		 * @param videos_element {Object} Main wrapper object for videos element
		 * @param referent {Boolean} Whether to get player referent size
		 */
		setPlayerSizeForCompare : function(videos_element, referent) {
			var mod = this;

			// Referent player size
			if (referent === true) {
				mod.iv.player.referent = mod.SCS_INTERACTIVE_VIDEO_REFERENT_WIDTH + mod.SCS_INTERACTIVE_VIDEO_REFERENT_HEIGHT;
			}

			// The player is different then referent dimensions, let's check how much
			mod.iv.player.resize_proportion = ((100 * (videos_element.width() + videos_element.outerHeight(true))) / mod.iv.player.referent).toFixed();
		},

		/**
		 * If window resize check the overlay buttons size
		 */
		onResizeChange : function() {
			var mod = this;

			// Start listening for resize event
			w.onresize = function() {
				mod.setPlayerSizeForCompare(mod.iv.videos_element);
				mod.prepareButtons(mod.iv.videos_elements_byIDs[mod.iv.currentVideo]);
			};
		},

		/**
		 * Because video is responsive on mobile devices,
		 * we will resize overlay buttons accordingly
		 *
		 * @param button {Object} Video button element
		 */
		resizeOverlayButtons : function(button) {
			var mod = this,
				$button_image = button.find('> img');

			// Just in case check if we have button
			if (typeof button === 'undefined') {
				debug.log('Tc.Module.InteractiveVideo.js > Iterate function returned empty video button.');
			}

			// Remove border from button
			button.css({
				'font-size': '',
				'line-height': ''
			});

			// Check referent dimensions
			if (mod.iv.player.resize_proportion !== 100) {

				// Check if button has image
				if ($button_image.length) {
					button.css('width', (($button_image.attr('width') * mod.iv.player.resize_proportion)) / 100 + 'px');

				// If not, try to resize font
				} else {
					if (mod.iv.player.resize_proportion > 100) {
						button.css({
							'font-size': mod.iv.player.resize_proportion + '%',
							'line-height': mod.iv.player.resize_proportion + '%'
						});
					}
				}
			}
		},

		/**
		 * Calculate and set negative margin for center and middle buttons
		 *
		 * @param button {Object} overlay button object
		 * @param button_width {Integer} button element width
		 * @param button_height {Integer} button element height
		 */
		overlayButtonsDimensions : function(button, button_width, button_height) {
			var mod = this;

			// Check for center column
			if(button.hasClass(mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS + '-center') && button_width > 0) {
				button.css('margin-left', - (button_width / 2).toFixed() + 'px');
			}

			// Check for middle row
			if(button.hasClass(mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS + '-middle') && button_height > 0) {
				button.css('margin-top', - (button_height / 2).toFixed() + 'px');
			}
		},

		/**
		 * Check if all images have been loaded
		 *
		 * @param video_element {Object} Video element object
		 *
		 * @return {Boolean} Whether or not has all images been loaded
		 */
		isLoaded: function($element) {
			return $element.find('img')
				.filter(function() {
					return this.complete;
				}).length > 0;
		}
	});
})(Tc.$, window, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/shared/js/modules/Tc.Module.InteractiveVideo.js
// module id = 353
// module chunks = 0